import React, { Component } from 'react';
import './page.scss';

import queryString from 'query-string';
import axios from 'axios';
import moment from 'moment';
import { Line } from 'react-chartjs-2';

// components
import Loader from '../components/Loader/Loader';
import { getQs } from 'services/queryString'

class Chart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      datas: [],
      apiError: false,
      // path and params
      apiPath: null,
      entity: null, // affiliate/seller/supplier/account
      id: null,
      startDate: null,
      endDate: null,
      filterBy: null
    };
  }

  componentWillMount() {
    const {
      path,
      params: { id }
    } = this.props.match;
    const { from, to, dim } = queryString.parse(this.props.location.search);
    this.setState({
      apiPath: path,
      id,
      startDate: from,
      endDate: to,
      filterBy: dim
    });
  }

  componentDidMount() {
    const { apiPath, id, startDate, endDate } = this.state;
    if (id && this.parametersAreValid(startDate, endDate) && apiPath) {
      this.setState({ loading: true }, () => {
        const apiUrl = this.buildApiUrl(apiPath, id, startDate, endDate);
        if (apiUrl) {
          const token = getQs("token")
          axios
            .get(
              apiUrl,
              token
                ? {
                    headers: { authorization: `Bearer ${getQs("token")}` },
                  }
                : undefined
            )
            .then((res) => {
              if (res && res.status === 200) {
                this.setState({
                  loading: false,
                  apiError: false,
                  datas: res.data || [],
                });
              } else {
                this.setState({ loading: false, apiError: true });
              }
            });
        }
      });
    }
  }

  buildApiUrl(apiPath, id, startDate, endDate) {
    let entity = null;
    let url = null;
    if (apiPath.includes('affiliates')) {
      entity = 'affiliate';
      url = `https://business-api.musement.com/api/reports/DWH/_proc/rpt_Affiliate_Sales?idAffiliate=${id}&dtBookedStart=${startDate}&dtBookedEnd=${endDate}&SortBy=1&Sorting=ASC`;
    } else if (apiPath.includes('suppliers')) {
      entity = 'supplier';
      url = `https://business-api.musement.com/api/reports/DWH/_proc/rpt_Supplier_Sales?uuidSupplier=${id}&dtBookedStart=${startDate}&dtBookedEnd=${endDate}&SortBy=1&Sorting=ASC`;
    } else if (apiPath.includes('sellers')) {
      entity = 'seller';
      url = `https://business-api.musement.com/api/reports/DWH/_proc/rpt_Seller_Sales?idSeller=${id}&dtBookedStart=${startDate}&dtBookedEnd=${endDate}&SortBy=1&Sorting=ASC`;
    } else if (apiPath.includes('account')) {
      entity = 'account';
      url = `https://business-api.musement.com/api/reports/DWH/_proc/rpt_Account_Sales?uuidAccount=${id}&dtBookedStart=${startDate}&dtBookedEnd=${endDate}&SortBy=1&Sorting=ASC`;
    } else return null;
    this.setState({ entity });

    return url;
  }

  parametersAreValid(startDate, endDate) {
    return (
      startDate &&
      endDate &&
      moment(startDate, 'YYYY-MM-DD', true).isValid() &&
      moment(endDate, 'YYYY-MM-DD', true).isValid()
    );
  }

  render() {
    const { loading, datas, startDate, endDate, filterBy } = this.state;
    const labels = datas.map(o => o.BookingDate);
    const data = datas.map(o => o[filterBy]);

    if (loading) return <Loader />;

    if (!this.parametersAreValid(startDate, endDate)) {
      return (
        <div className="page full-height">
          <p className="page-error">Invalid startDate or endDate values.</p>
        </div>
      );
    }

    if (!filterBy) {
      return (
        <div className="page full-height">
          <p className="page-error">Invalid dim value.</p>
        </div>
      );
    }

    return (
      <div className="page full-height">
        {/* <div className="page-header">
          <p className="page-header--title">{`${filterBy} Report`}</p>
        </div> */}
        <Line
          data={{
            labels: labels,
            datasets: [
              {
                label: filterBy,
                backgroundColor: 'rgba(255, 99, 132, 0.3)',
                borderColor: 'rgb(255, 99, 132)',
                data: data
              }
            ]
          }}
        />
      </div>
    );
  }
}

export default Chart;
